import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resize"
export default class extends Controller {
  static values = { feedbackText: String };
  static targets = ["button", "container"];

  connect() {
    this.initialButtonText = this.buttonTarget.textContent.trim();
    this.initialContainerSize =
      this.containerTarget.getBoundingClientRect().height;
    this.resizeOption = "maximize";
  }

  toggleSize(event) {
    this[this.resizeOption]();
    event.currentTarget.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  maximize() {
    this.resizeOption = "minimize";
    this.buttonTarget.innerText = this.feedbackTextValue;
    const maxHeight = window.screen.height - 200;
    this.containerTarget.style.height = maxHeight;
  }

  minimize() {
    this.resizeOption = "maximize";
    this.buttonTarget.innerText = this.initialButtonText;
    this.containerTarget.style.height = this.initialContainerSize;
  }
}
